import { Injectable } from '@angular/core';
import { StorageProvider } from '../storage/storage';
import { StorageType } from 'model/types/storage-type';
import { APP_CONFIG } from '../../environment';

// Define an enum for Reminder Interval Types
// In case you are updating types then update in pre-login screen as well
export type ReminderIntervalType =  'minute' | 'hourly' | 'daily' | 'weekly' | 'monthly';

const DISABLED = 'DISABLED';

@Injectable()
export class ReminderProvider {

    constructor(private storageProvider: StorageProvider){}

    private getNextDate(lastDate: Date, interval?: ReminderIntervalType): Date {
        const nextDate = new Date(lastDate);
        switch (interval) {
            case 'minute':
                nextDate.setMinutes(nextDate.getMinutes() + 1);
                break;
            case 'hourly':
                nextDate.setHours(nextDate.getHours() + 1);
                break;
            case 'daily':
                nextDate.setDate(nextDate.getDate() + 1);
                break;
            case 'weekly':
                nextDate.setDate(nextDate.getDate() + 7);
                break;
            case 'monthly':
                nextDate.setMonth(nextDate.getMonth() + 1);
                break;
        }
        return nextDate;
    }

    async shouldTriggerReminder(key: StorageType): Promise<boolean> {

        const storedValue = await this.storageProvider.get(key);
        const now = new Date();

        if (!storedValue) {
            // First time setup
            await this.storageProvider.set(key, now.toISOString());
            return true;
        }

        if (storedValue === DISABLED) {
            // Reminder was explicitly disabled
            return false;
        }

        const storedDate = new Date(storedValue);

        const nextDueDate = new Date(storedValue);

        if (now >= nextDueDate) {
            // Reminder is due — keep returning true until user extends
            return true;
        }

        return false;
    }

    // Disable the reminder (won't trigger again unless re-enabled)
    async removeReminder(key: string): Promise<void> {
        await this.storageProvider.set(key, DISABLED);
    }

    // Re-enable a disabled reminder by setting it to now
    async enableReminder(key: string): Promise<void> {
        const now = new Date();
        await this.storageProvider.set(key, now.toISOString());
    }

    async extendReminder(key: string, interval?: ReminderIntervalType): Promise<void> {
        const now = new Date();
        const reminderInterval = interval || APP_CONFIG.reminderInterval.toLowerCase();
        const nextDueDate = this.getNextDate(now, reminderInterval as ReminderIntervalType);

        await this.storageProvider.set(key, nextDueDate.toISOString());
      }
}



// WEBPACK FOOTER //
// ./src/providers/reminder-provider/reminder-provider.ts